import Checkbox from 'antd/lib/checkbox';
import Divider from 'antd/lib/divider';
import Form from 'antd/lib/form';
import Typography from 'antd/lib/typography';
import Tooltip from 'antd/lib/tooltip';
import { InfoCircleOutlined } from '@ant-design/icons';
import React, { useMemo } from 'react';
import { UserType } from '../../domain/user/interface';

import './NotificationsSettings.css';

interface INotificationsSettingsProps {
    userType: UserType;
}

export const NotificationsSettings: React.FC<INotificationsSettingsProps> = ({ userType }) => {
    const notificationConfigs = useNotificationConfigs(userType);

    return (
        <>
            <Divider plain>Notification</Divider>
            <table className="notification-table">
                <thead>
                    <tr>
                        <th></th>
                        <th>Email</th>
                        <th>Sms</th>
                    </tr>
                </thead>
                <tbody>
                    {notificationConfigs.map(notificationConfig => {
                        if (notificationConfig.hidden) return null;

                        return (
                            <tr key={notificationConfig.title}>
                                <td>
                                    <Typography.Text strong>
                                        {notificationConfig.title}&nbsp;{notificationConfig.info}
                                    </Typography.Text>
                                </td>
                                {notificationConfig.paths.map(path => (
                                    <td key={`${path}`}>
                                        <Form.Item name={path} initialValue={true} valuePropName="checked" noStyle>
                                            <Checkbox />
                                        </Form.Item>
                                    </td>
                                ))}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </>
    );
};

function useNotificationConfigs(userType: UserType) {
    return useMemo(
        () => [
            {
                title: 'Event Created/Updated:',
                info: (
                    <Tooltip title="Notify about Create/Update Event, Create Standby Period, Ongoing Event Notification">
                        <InfoCircleOutlined style={{ color: 'var(--ant-color-primary)' }} />
                    </Tooltip>
                ),
                paths: [
                    ['notification_settings', 'event_created', 'email'],
                    ['notification_settings', 'event_created', 'sms'],
                ],
            },
            {
                title: 'Pre Event:',
                paths: [
                    ['notification_settings', 'pre_event', 'email'],
                    ['notification_settings', 'pre_event', 'sms'],
                ],
            },
            {
                title: 'Event Started:',
                paths: [
                    ['notification_settings', 'event_started', 'email'],
                    ['notification_settings', 'event_started', 'sms'],
                ],
            },
            {
                title: 'Event Completed:',
                info: (
                    <Tooltip title="Notify about Event Completed and Event Cancelled">
                        <InfoCircleOutlined style={{ color: 'var(--ant-color-primary)' }} />
                    </Tooltip>
                ),
                paths: [
                    ['notification_settings', 'event_completed', 'email'],
                    ['notification_settings', 'event_completed', 'sms'],
                ],
            },
            {
                title: 'Season Readiness:',
                paths: [['notification_settings', 'nomination_readiness', 'email']],
                hidden: ![UserType.CUSTOMER, UserType.OPERATOR].includes(userType),
            },
        ],
        [userType]
    );
}
